import { Action } from '@ngrx/store';

export const VIEW_CONFERENCE_CONFIRMATION =
  '[Confirmation] View Conference Confirmation';
export const VIEW_CONFERENCE_CONFIRMATION_SUCCESS =
  '[Confirmation] View Conference Confirmation Success';
export const VIEW_CONFERENCE_CONFIRMATION_FAIL =
  '[Confirmation] View Conference Confirmation Fail';

export const VIEW_ACCOMMODATION_CONFIRMATION =
  '[Confirmation] View Accommodation Confirmation';
export const VIEW_ACCOMMODATION_CONFIRMATION_SUCCESS =
  '[Confirmation] View Accommodation Confirmation Success';
export const VIEW_ACCOMMODATION_CONFIRMATION_FAIL =
  '[Confirmation] View Accommodation Confirmation Fail';

export class ViewConferenceConfirmation implements Action {
  readonly type = VIEW_CONFERENCE_CONFIRMATION;
  constructor(public payload: string) {}
}

export class ViewConferenceConfirmationSuccess implements Action {
  readonly type = VIEW_CONFERENCE_CONFIRMATION_SUCCESS;
  constructor(public payload: any) {}
}

export class ViewConferenceConfirmationFail implements Action {
  readonly type = VIEW_CONFERENCE_CONFIRMATION_FAIL;
  constructor(public payload: any) {}
}

export class ViewAccommodationConfirmation implements Action {
  readonly type = VIEW_ACCOMMODATION_CONFIRMATION;
  constructor(public payload: string) {}
}

export class ViewAccommodationConfirmationSuccess implements Action {
  readonly type = VIEW_ACCOMMODATION_CONFIRMATION_SUCCESS;
  constructor(public payload: any) {}
}

export class ViewAccommodationConfirmationFail implements Action {
  readonly type = VIEW_ACCOMMODATION_CONFIRMATION_FAIL;
  constructor(public payload: any) {}
}

export type confirmationAction =
  | ViewConferenceConfirmation
  | ViewConferenceConfirmationSuccess
  | ViewConferenceConfirmationFail
  | ViewAccommodationConfirmation
  | ViewAccommodationConfirmationSuccess
  | ViewAccommodationConfirmationFail;



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/actions/confirmation.action.ts